import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-308b884f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'
import { addPlatform,allPlatform,delPlatform,addSysConfig,getSysConfig} from '../../api'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const visible11 = ref(false);

const current1 = ref("1")
const selectedKeys = ref([]);

const dataSource = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "平台名称", key: "name", align: "center" },
  { title: "appLogo", key: "logo", align: "center"},
  { title: "状态", key: "state", align: "center" },
  { title: "图片域名", key: "picture", align: "center" }, 
  { title: "图片水印", key: "watermark", align: "center"  },
  { title: "单文件大小", key: "oneUploadSize", align: "center" },
  { title: "每次多少张", key: "howManySheets", align: "center" },
  { title: "发布数量", key: "releasesNum", align: "center" },
  { title: "飞机频道", key: "airplane", align: "center" },
  { title: "TG客服", key: "ca", align: "center" },
  { title: "公告", key: "announcement", align: "center" }, 
  { title: "添加时间", key: "addTime", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
]);


const getAllPlatform = () => {
  var data = { "page": page.current, "limit": page.limit};
  allPlatform(data).then((res: any) => {
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}

getAllPlatform();

 


const platform = reactive({
  id:0,
  mark: "",
  name: "",
  state: 1,
  announcement:"",
  picture:"",
  logo:"",
  watermark:"",
  oneUploadSize:0,
  howManySheets:0,
  releasesNum:0,
  airplane:"", 
  ca:""
 

})

const changeVisible11 = () => {
  platform.id=0,
  platform.mark="",
  platform.name="",
  platform.state= 1, 
  platform.announcement="",
  platform.picture="",
  platform.logo="",
  platform.watermark="",
  platform.oneUploadSize=0,
  platform.howManySheets=0,
  platform.releasesNum=0,
  platform.airplane="",
  platform.ca="", 
  visible11.value = !visible11.value;
}

const updatePlatform = (row: any) => {
  platform.id=row.id,
  platform.mark=row.mark,
  platform.name=row.name,
  platform.state= row.state,   
  platform.announcement=row.announcement,
  platform.picture=row.picture,
  platform.logo=row.logo,
  platform.watermark=row.watermark,
  platform.oneUploadSize=row.oneUploadSize,
  platform.howManySheets=row.howManySheets,
  platform.releasesNum=row.releasesNum,
  platform.airplane=row.airplane,
  platform.ca=row.ca, 
  visible11.value = !visible11.value;
}


const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addPlatform(JSON.stringify(platform)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllPlatform();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false; 
    }
  }
])



 

const deletePlatform=(row:any,)=>{
  var data={'id':row.id} 
  delPlatform(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllPlatform();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })

}




const submitConfig=()=>{
     addSysConfig(JSON.stringify(confingIfon)).then((res: any) => {
        if (res != "" && res.code == 0) { 
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })

}





const confingIfon = reactive({
  automatic: true,
  guarantee: false,
  titleDay: "",
  pictureDay: "",
  summaryDay: "", 
})
 




const getAllSysConfig=()=>{
  getSysConfig().then((res: any) => {
        if (res != "" && res.code == 0) { 
          confingIfon.automatic=res.data.automatic
          confingIfon.guarantee=res.data.guarantee
          confingIfon.titleDay=res.data.titleDay
          confingIfon.pictureDay=res.data.pictureDay
          confingIfon.summaryDay=res.data.summaryDay 
        }
      })

}

getAllSysConfig()




 
 

return (_ctx: any,_cache: any) => {
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_field = _resolveComponent("lay-field")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "8" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_field, { title: "自动审核配置" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form, {
                      model: confingIfon,
                      pane: "true"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_form_item, {
                          label: "自动审核",
                          prop: "automatic",
                          mode: "inline",
                          style: {"display":"block"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_switch, {
                              modelValue: confingIfon.automatic,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((confingIfon.automatic) = $event)),
                              style: {"width":"0px !important"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "官方担保",
                          prop: "guarantee",
                          mode: "inline",
                          style: {"display":"block"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_switch, {
                              modelValue: confingIfon.guarantee,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confingIfon.guarantee) = $event)),
                              style: {"width":"0px !important"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "标题",
                          prop: "titleDay",
                          tips: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: confingIfon.titleDay,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confingIfon.titleDay) = $event)),
                              placeholder: "标题多少天之内不能重复"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "图片",
                          prop: "pictureDay",
                          tips: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: confingIfon.pictureDay,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confingIfon.pictureDay) = $event)),
                              placeholder: "图片多少天之内不能重复"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "简介",
                          prop: "summaryDay",
                          tips: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: confingIfon.summaryDay,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confingIfon.summaryDay) = $event)),
                              placeholder: "简介多少天之内不能重复"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, { style: {"text-align":"center"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_button, {
                              type: "primary",
                              onClick: submitConfig
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("提交")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "16" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_lay_field, { title: "平台节点配置" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_lay_button, {
                        size: "sm",
                        onClick: changeVisible11,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_lay_table, {
                      height: '100%',
                      columns: columns.value,
                      "data-source": dataSource.value,
                      "selected-keys": selectedKeys.value,
                      "onUpdate:selectedKeys": _cache[5] || (_cache[5] = ($event: any) => ((selectedKeys).value = $event))
                    }, {
                      operator: _withCtx(({ row }) => [
                        _createVNode(_component_lay_button, {
                          size: "xs",
                          type: "primary",
                          onClick: ($event: any) => (updatePlatform(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_lay_button, {
                          size: "xs",
                          type: "danger",
                          onClick: ($event: any) => (deletePlatform(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["columns", "data-source", "selected-keys"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['600px', '800px'],
      btn: action11.value,
      title: "添加平台/修改平台"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: platform,
            ref: "layFormRef11"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "平台名字",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.name,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((platform.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "logo地址：",
                prop: "logo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.logo,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((platform.logo) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "图片地址：",
                prop: "picture"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.picture,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((platform.picture) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "图片水印：",
                prop: "watermark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.watermark,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((platform.watermark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "单文件大小：",
                prop: "oneUploadSize"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.oneUploadSize,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((platform.oneUploadSize) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "每次多少张：",
                prop: "howManySheets"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.howManySheets,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((platform.howManySheets) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "每天发布数量：",
                prop: "releasesNum"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.releasesNum,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((platform.releasesNum) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "飞机频道：",
                prop: "airplane"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.airplane,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((platform.airplane) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "TG客服：",
                prop: "ca"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.ca,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((platform.ca) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "公告：",
                prop: "announcement"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.announcement,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((platform.announcement) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})